export const SET_CLIENT = 'SET_CLIENT';
export const SET_COMMANDES = 'SET_COMMANDES';



// WEBPACK FOOTER //
// ./src/store/modules/client-mutation-type.js